import React from 'react';
import { Typography } from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { MIN_SEARCH_INPUT_WIDTH } from './constants';

interface SearchInputProps {
  inputRef: React.RefObject<HTMLInputElement>;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  activeFieldName: string | null;
  hasFilters: boolean;
  onClearActiveField?: () => void;
  onEnterPress?: (value: string) => void;
  onCancelEdit?: () => void;
}

const PLACEHOLDER_TEXT = 'Search';

export const SearchInput = ({
  inputRef,
  value,
  onChange,
  onFocus,
  activeFieldName,
  hasFilters,
  onClearActiveField,
  onEnterPress,
  onCancelEdit,
}: SearchInputProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && value === '' && activeFieldName) {
      onClearActiveField?.();
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      onCancelEdit?.();
      return;
    }

    if (e.key === 'Enter' && value.trim() && !activeFieldName) {
      e.preventDefault();
      onEnterPress?.(value.trim());
    }
  };

  return (
    <>
      {activeFieldName && (
        <Typography
          component="span"
          sx={{
            fontSize: '1.2rem',
            px: 0.75,
            color: abyssColors.primary[500],
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          {activeFieldName}:
        </Typography>
      )}
      <input
        ref={inputRef}
        type="text"
        placeholder={hasFilters || activeFieldName ? '' : PLACEHOLDER_TEXT}
        aria-label="Filter input"
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={handleKeyDown}
        style={{
          border: 'none',
          outline: 'none',
          flex: 1,
          minWidth: MIN_SEARCH_INPUT_WIDTH,
          fontSize: '1.2rem',
          color: abyssColors.primary[500],
          backgroundColor: 'transparent',
        }}
      />
    </>
  );
};
